<template>
  <div class="card mt-4" style="overflow: hidden">
    <div class="table-responsive" style="overflow-x: auto; overflow-y: hidden">
      <div class="table-controls m-3">
        <div class="controls-wrap d-flex">
          <!-- Integration Field -->
          <Search @search="doSearch" placeholderText="Search (name)" class="mr-3" />

          <div class="mr-3 ml-auto">
            <v-select
              style="min-width: 350px"
              v-model="listOfSelectedEmployers"
              @input="handleSearchFilters"
              :options="getEmployersDropdown"
              placeholder="All Employers"
              inputId="employer-select"
              label="name"
              multiple
              :reduce="employer => employer"
              :clearable="true"
              ><!-- <template #option="{ name, city }"> {{ name }} - {{ city }} </template> --></v-select
            >
          </div>

          <!-- <div v-show="!isPreviouslyReviewed" class="align-items-center published popover-show">
            <span
              class="fa-stack"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Include previously reviewed applications"
              @click="
                isPreviouslyReviewed = !isPreviouslyReviewed;
                handleSearchFilters($event);
              "
            >
              <i
                class="fas fa-user-check fa-stack-1x fa-inverse"
                :class="isPreviouslyReviewed ? 'is-clicked' : ''"
              ></i>
            </span>
          </div> -->

          <div class="align-items-center published popover-show">
            <span
              class="fa-stack"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              :title="
                isPreviouslyReviewed
                  ? 'Exclude previously reviewed applications'
                  : 'Include previously reviewed applications'
              "
              @click="
                isPreviouslyReviewed = !isPreviouslyReviewed;
                handleSearchFilters($event);
              "
            >
              <i
                class="fas fa-user-check fa-stack-1x fa-inverse"
                :class="isPreviouslyReviewed ? 'is-clicked' : ''"
              ></i>
            </span>
          </div>
        </div>
      </div>
      <div class="overflow">
        <div v-if="isLoading" class="loader-con"><Spinner :isLoading="isLoading" /></div>

        <table v-else class="table table-striped custom-table" style="table-layout: auto">
          <thead class="bg-dark text-white">
            <tr>
              <th scope="col">RATING</th>
              <th scope="col">NAME</th>
              <th scope="col">POSITION</th>
              <th scope="col">EMPLOYER</th>
              <th scope="col">LOCATION</th>
              <th scope="col">
                <!-- Type -->
                &nbsp;
              </th>
              <th scope="col">
                <!-- Documents -->
                &nbsp;
              </th>
              <!--  <th scope="col">SOURCE</th> -->
              <th scope="col">APPLIED</th>
              <th scope="col">QUALIFICATION</th>
              <th scope="col">STAGE</th>
              <th scope="col">&nbsp;</th>
            </tr>
          </thead>

          <tbody>
            <ApplicationTableItem
              v-for="application in reviewApplicationsLocalList"
              :key="application.pipeline_id"
              :application="application"
              :user="getCandidateById"
              @update-activity-row="updateTableRow"
              @application-reload="reloadApplications"
              @submit-activity-row="submitTableRow"
            />
          </tbody>
        </table>
      </div>

      <ErrorList class="no-data-message" v-show="applications.length" name="noApplications" />
    </div>

    <div class="d-flex ml-auto mt-auto bottom-controls">
      <div id="pagination" class="desktop-only">
        <!-- Pagination -->
        <Pagination
          :currentPage="getCurrentPage"
          :totalPages="getTotalPages"
          @nextPage="nextPage"
          @prevPage="previousPage"
          @selectPageByNumber="setPageByNumber"
          @firstPage="setToFirstPage"
          @lastPage="setToLastPage"
          @keyup="keymonitor"
        />
      </div>
    </div>

    <!-- Mobile Interface Starts -->
    <section class="mobile-qualify mobile-only">
      <ul class="list-unstyled">
        <li>
          <div class="d-flex align-items-center">
            <span class="name"><a href="#">Ahmed Rabie</a></span>
            <span class="company ml-auto"><a href="#">Comstream</a></span>
          </div>
          <div class="d-flex align-items-center">
            <span class="email">apjobshark@jobshark.se</span>
            <span class="position ml-auto"> <a href="#"> Java Developer</a></span>
          </div>
          <div class="d-flex align-items-center">
            <div class="documents">
              <router-link class="mr-2" slot="reference" to>
                <svgHelper name="linkedin" />
              </router-link>

              <popper
                trigger="hover"
                :options="{
                  placement: 'top',
                  modifiers: { offset: { offset: '0,10px' } },
                }"
              >
                <div class="popper">Doc name {{ 'result' }}</div>
                <router-link slot="reference" to>
                  <svgHelper name="documentPdf" class="mr-2" />
                </router-link>
              </popper>

              <div class="dropdown">
                <button
                  v-show="true"
                  type="button"
                  class="btn btn-danger dropdown-toggle"
                  id="competencesDropDown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                ></button>

                <ul class="list-inline dropdown-menu w-100" aria-labelledby="competencesDropDown">
                  <li v-for="(c, i) in 3" :key="i" class="list-inline-item">
                    {{ 'icon' }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="action-buttons ml-auto">
              <router-link to>
                <svgHelper
                  class="mr-2 green"
                  data-toggle="modal"
                  data-target=".bd-like-btn"
                  name="thumbsUp"
                />
              </router-link>
              <router-link to>
                <svgHelper
                  data-toggle="modal"
                  data-target="#reject-modal"
                  class="mr-2 red"
                  name="thumbsDown"
                />
              </router-link>
            </div>
          </div>
        </li>
        <li>
          <div class="d-flex align-items-center">
            <span class="name"><a href="#">Ahmed Rabie</a></span>
            <span class="company ml-auto"><a href="#">Comstream</a></span>
          </div>
          <div class="d-flex align-items-center">
            <span class="email">apjobshark@jobshark.se</span>
            <span class="position ml-auto"><a href="#">Java Developer</a></span>
          </div>
          <div class="d-flex align-items-center">
            <div class="documents">
              <router-link class="mr-2" slot="reference" to>
                <svgHelper name="linkedin" />
              </router-link>

              <popper
                trigger="hover"
                :options="{
                  placement: 'top',
                  modifiers: { offset: { offset: '0,10px' } },
                }"
              >
                <div class="popper">Doc name {{ 'result' }}</div>
                <router-link slot="reference" to>
                  <svgHelper name="documentPdf" class="mr-2" />
                </router-link>
              </popper>
            </div>
            <div class="action-buttons ml-auto">
              <router-link to>
                <svgHelper
                  class="mr-2 green"
                  data-toggle="modal"
                  data-target=".bd-like-btn"
                  name="thumbsUp"
                ></svgHelper>
              </router-link>
              <router-link to>
                <svgHelper
                  data-toggle="modal"
                  data-target=".bd-dislike-btn"
                  class="mr-2 red"
                  name="thumbsDown"
                ></svgHelper>
                <portal to="dislike-btn-modal">
                  <div
                    class="modal fade bd-dislike-btn"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="mainModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                      <div class="modal-content">
                        <div class="modal-body">
                          <p>
                            {{ '[First name]' }} {{ '[Last name]' }} will not be submitted to
                            {{ '[Employer]' }} for the position as {{ '[Position]' }}
                          </p>
                          Documents
                          <ul>
                            <li>doc 1 full service</li>
                            <li>doc 2</li>
                            <li>doc 3</li>
                            <li>doc 4</li>
                          </ul>
                        </div>
                        <div class="modal-footer d-flex justify-content-center">
                          <button type="button" class="btn btn-primary">OK</button>
                          <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </portal>
              </router-link>
            </div>
          </div>
        </li>
        <li>
          <div class="d-flex align-items-center">
            <span class="name"><a href="#">Ahmed Rabie</a></span>
            <span class="company ml-auto"><a href="#">Comstream</a></span>
          </div>
          <div class="d-flex align-items-center">
            <span class="email">apjobshark@jobshark.se</span>
            <span class="position ml-auto"><a href="#">Java Developer</a></span>
          </div>
          <div class="d-flex align-items-center">
            <div class="documents">
              <router-link class="mr-2" slot="reference" to>
                <svgHelper name="linkedin" />
              </router-link>

              <popper
                trigger="hover"
                :options="{
                  placement: 'top',
                  modifiers: { offset: { offset: '0,10px' } },
                }"
              >
                <div class="popper">Doc name {{ 'result' }}</div>
                <router-link slot="reference" to>
                  <svgHelper name="documentPdf" class="mr-2" />
                </router-link>
              </popper>
            </div>
            <div class="action-buttons ml-auto">
              <router-link to>
                <svgHelper
                  class="mr-2 green"
                  data-toggle="modal"
                  data-target=".bd-like-btn"
                  name="thumbsUp"
                />

                <portal to="like-btn-modal">
                  <div
                    class="modal fade bd-like-btn"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="mainModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                      <div class="modal-content">
                        <div class="modal-header"><h5>Submit Candidate</h5></div>
                        <div class="modal-body">
                          <p>
                            Please confirm that {{ pipelineForSubmit.first_name }}
                            {{ pipelineForSubmit.last_name }} should be submitted for the role
                            {{ getJobAdById.title }}, {{ getJobAdById.employer_name }}
                          </p>

                          <div class="mt-3">
                            <form ref="submitCandidateFileForm" key="submitCandidateFileFormKey">
                              <div class="dropzone p-4">
                                <div class="dropzone-message file-drag-drop">
                                  <p class="small drop-files">
                                    Upload document here or click to browse for file.
                                  </p>

                                  <label
                                    for="file"
                                    class="btn btn-primary btn-sm file-upload-label mb-0"
                                    >Browse</label
                                  >
                                  <input
                                    type="file"
                                    id="applications-file"
                                    ref="file"
                                    @change="handleFileUpload"
                                    class="file-upload-input"
                                  />

                                  <ul class="list-group file-listing mt-3">
                                    <li
                                      v-for="(file, key) in files"
                                      :key="key"
                                      class="list-group-item d-flex align-items-center small"
                                    >
                                      <span class="mr-3">
                                        <i
                                          ref="primaryIcon"
                                          title="Primary CV"
                                          @click="setAsDefault($event)"
                                          :id="key"
                                          :class="[
                                            icons.crownIcon,
                                            itemId == key ? icons.crownIconSelected : '',
                                          ]"
                                        ></i>
                                      </span>
                                      <span class="mr-auto">{{ file.name }}</span>
                                      <span class="badge badge-primary badge-pill ml-auto">{{
                                        `${(file.size / 1024 / 1024).toFixed(2)} MB`
                                      }}</span>
                                      <span class="remove-container ml-4">
                                        <span class="remove" v-on:click="removeFile(key)">×</span>
                                      </span>
                                    </li>
                                  </ul>

                                  <progress
                                    v-if="isUploading"
                                    max="100"
                                    :value.prop="uploadPercentage"
                                  ></progress>
                                  <div v-if="isUploading && uploadPercentage < 100" class="small">
                                    {{ `${uploadPercentage}%` }}
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                        <div class="modal-footer d-flex justify-content-center">
                          <button type="button" class="btn btn-primary btn-custom">Submit</button>
                          <button
                            type="button"
                            class="btn btn-secondary btn-custom"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </portal>
              </router-link>
              <router-link to>
                <svgHelper
                  data-toggle="modal"
                  data-target=".bd-dislike-btn"
                  class="mr-2 red"
                  name="thumbsDown"
                ></svgHelper>
                <portal to="dislike-btn-modal">
                  <div
                    class="modal fade bd-dislike-btn"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="mainModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
                      <div class="modal-content">
                        <div class="modal-body text-center">
                          <p>
                            {{ '[First name]' }} {{ '[Last name]' }} will not be submitted to
                            {{ '[Employer]' }} for the position as {{ '[Position]' }}

                            <!-- Qualification should be set to "Not in consideration". Stage should be set to "Not Submitted". -->
                          </p>
                        </div>
                        <div class="modal-footer d-flex justify-content-center">
                          <button type="button" class="btn btn-primary">OK</button>
                          <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </portal>
              </router-link>
            </div>
          </div>
        </li>
      </ul>
    </section>
    <!-- Mobile Interface Ends -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Pagination from '@/components/Navigations/Pagination';
import Search from '../../common/Search/Search';
/* import CustomMainModal from '@/components/Modals/CustomMainModal';
import AddCandidateBtnModal from '@/components/Admin/Candidates/AddCandidateBtnModal'; */

import { selectDefaultDocument } from '../../../mixins/selectDefaultDocumentMixin';
import { displayResultsBasedOnScreenHeightMixin } from '../../../mixins/displayResultsBasedOnScreenHeightMixin';

import ErrorList from '../../common/errorsList.vue';
import { errorService } from '../../../services/errorService';

import ApplicationTableItem from './ApplicationTableItem.vue';
import titleMixin from '../../../mixins/titleMixin';
// import moment from 'moment';

export default {
  components: {
    Pagination,
    Search,
    /* CustomMainModal,
    AddCandidateBtnModal, */
    ErrorList,
    ApplicationTableItem,
  },
  mixins: [selectDefaultDocument, displayResultsBasedOnScreenHeightMixin, titleMixin],
  title() {
    return 'Review applications | Jobshark';
  },
  data: () => ({
    applicationDocuments: [],
    comment: '',
    pipelineForSubmit: {},
    pipelineForUpdate: {},
    pipelineForDelete: '',
    selectedDocuments: [],
    isSubmitted: false,
    applications: [],
    dragAndDropCapable: false,
    isUploading: false,
    uploadPercentage: 10,
    isPrimary: true,
    primaryCv: true,
    file: '',
    files: [],
    isPreviouslyReviewed: false,
    isLoading: true,
    listOfSelectedEmployers: [],
    currentPage: 1,
    pageCount: 10,
    showModal: false,
    searchText: '',
    approveModalData: {},
    rejectModalData: {},
    candidateNames: '',
    selectedStage: '',
    serviceLevel: '2',
    reviewApplicationsLocalList: [],
  }),
  methods: {
    ...mapActions([
      'retrieveCandidates',
      'retrieveSourcesList',
      'removeReviewApplication',
      'retrieveDocumentPreview',
      'retrieveCandidateDocument',
      'retrieveEmployersDropdown',
      'retrieveReviewApplications',
      'updatePipelineForCandidate',
      'retrieveUserProfile',
    ]),
    updateTableRow(updatedRow) {
      const currentApplicationsList = this.$store.state.adminStore.reviewApplicationsList;

      const rowIndex = currentApplicationsList.findIndex(
        currentApplicationsRow => currentApplicationsRow.pipeline_id === updatedRow.pipeline_id,
      );

      if (rowIndex !== -1) {
        this.$set(this.reviewApplicationsLocalList, rowIndex, updatedRow);
      }
    },
    submitTableRow(submittedRow) {
      const rowIndex = this.reviewApplicationsLocalList.findIndex(
        r => r.pipeline_id === submittedRow.pipeline_id,
      );

      if (rowIndex !== -1) {
        this.$set(this.reviewApplicationsLocalList, rowIndex, submittedRow);
      }
    },
    reloadApplications() {
      this.retrieveReviewApplications({
        search_word: this.searchText,
        employers: this.listOfSelectedEmployers.map(item => item.id),
        page: Number(this.currentPage),
        count: Number(this.pageCount),
        previously_reviewed: this.isPreviouslyReviewed,
      })
        .then(({ data }) => {
          this.isLoading = false;
          this.reviewApplicationsLocalList = data.data;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    getDocumentProperties(fileName) {
      const re = /(?:\.([^.]+))?$/;
      if (re.exec(fileName)[1] === 'pdf') {
        return {
          color: '#ff0000',
          type: 'pdf',
        };
      } else if (re.exec(fileName)[1] === 'docx' || re.exec(fileName)[1] === 'doc') {
        return {
          color: '#005a9e',
          type: 'doc',
        };
      } else {
        return { color: '#a7a7a77', type: '' };
      }
    },
    handleCheckboxChange() {},

    /* setPipelineForUpdate(pipeline) {
      this.pipelineForUpdate = pipeline;
      this.selectedStage = this.getStageMixin(pipeline.stage).value;
      this.selectedQualification = this.getQualificationMixin(pipeline.qualification).value;

      this.candidateDocumentsFiles = pipeline.documents;
      this.selectedSource = pipeline['source_id'];
      this.candidateNames = `${pipeline.candidate_first_name} ${pipeline.candidate_last_name} - ${pipeline.job}`;
      this.selectedDocuments = [];
      pipeline.documents.forEach((doc) => {
        this.selectedDocuments.push(doc.id);
      });
    }, */

    /* File Upload Form */
    closeModal() {
      this.currentPage = 1;
      this.showModal = false;
    },
    setRejectModalData(application) {
      /*  console.log('setRejectModalData: ', application); */
      this.rejectModalData = application;
    },
    setApproveModalData(application) {
      /*  console.log('setApproveModalData: ', application); */
      this.approveModalData = application;
    },
    handleFileUpload() {
      if (this.files.length >= 1) {
        this.isPrimary = false;
      }

      for (let i = 0; i < this.files.length; i++) {
        let file = this.files[i];

        const fileSize = (file.size / 1024 / 1024).toFixed(2);

        if (fileSize > 20) {
          this.errorMessage = `The file size exceeds the limit of 20 MB.`;
        }
      }

      this.files.push({
        name: this.$refs.file.files[0].name,
        primary: this.isPrimary,
        size: this.$refs.file.files[0].size,
      });
    },
    removeFile(key) {
      this.files.splice(key, 1);
    },
    cancelUpload() {
      this.files = [];
      this.$emit('close');
    },
    determineDragAndDropCapable() {
      const div = document.createElement('div');
      return (
        ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) &&
        'FormData' in window &&
        'FileReader' in window
      );
    },
    /* End File Upload Form */
    doSearch(searchedText) {
      this.searchText = searchedText;

      this.currentPage = 1;

      if (this.searchText.length >= 3) {
        this.isLoading = true;

        this.retrieveReviewApplications({
          search_word: this.searchText,
          employers: this.listOfSelectedEmployers.map(item => item.id),
          previously_reviewed: this.isPreviouslyReviewed,
          page: Number(this.currentPage),
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }

      if (searchedText === '') {
        this.isLoading = true;
        setTimeout(() => {
          this.isLoading = false;
        }, 2000);

        this.searchText = searchedText;

        this.retrieveReviewApplications({
          search_word: this.searchText,
          employers: this.listOfSelectedEmployers.map(item => item.id),
          previously_reviewed: this.isPreviouslyReviewed,
          page: Number(this.currentPage),
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });

        /*    console.log('search for: ', this.searchText); */
      }
    },
    handleSearchFilters() {
      this.currentPage = 1;
      this.isLoading = true;

      this.retrieveReviewApplications({
        search_word: this.searchText,
        employers: this.listOfSelectedEmployers.map(item => item.id),
        page: this.currentPage,
        count: this.pageCount,
        previously_reviewed: this.isPreviouslyReviewed,
      })
        .then(({ data }) => {
          this.isLoading = false;
          this.reviewApplicationsLocalList = data.data;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        // this.nextPage();
        /*      console.log(keyMessage); */
      }

      if (keyMessage == 'ArrowLeft') {
        // this.previousPage();
        /* console.log(keyMessage); */
      }
    },
    nextPage() {
      if (this.currentPage >= 1) {
        this.isLoading = true;
        this.currentPage++;

        this.retrieveReviewApplications({
          search_word: this.searchText,
          employers: this.listOfSelectedEmployers.map(item => item.id),
          page: Number(this.currentPage),
          count: Number(this.pageCount),
          previously_reviewed: this.isPreviouslyReviewed,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;

            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.isLoading = true;
        --this.currentPage;

        this.retrieveReviewApplications({
          search_word: this.searchText,
          employers: this.listOfSelectedEmployers.map(item => item.id),

          page: Number(this.currentPage),
          count: Number(this.pageCount),
          previously_reviewed: this.isPreviouslyReviewed,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;

            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      } else {
        this.currentPage = 1;
      }
    },
    setPageByNumber(pageNumber) {
      if (pageNumber > this.getTotalPages || pageNumber < 1) return;
      this.isLoading = true;
      this.currentPage = pageNumber;

      this.retrieveReviewApplications({
        search_word: this.searchText,
        employers: this.listOfSelectedEmployers.map(item => item.id),

        page: Number(this.currentPage),
        count: Number(this.pageCount),
        previously_reviewed: this.isPreviouslyReviewed,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    setToFirstPage() {
      this.isLoading = true;
      this.currentPage = 1;

      this.retrieveReviewApplications({
        search_word: this.searchText,
        employers: this.listOfSelectedEmployers.map(item => item.id),

        page: Number(this.currentPage),
        count: Number(this.pageCount),
        previously_reviewed: this.isPreviouslyReviewed,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    setToLastPage(lastPage) {
      this.isLoading = true;
      this.currentPage = lastPage;

      this.retrieveReviewApplications({
        search_word: this.searchText,
        employers: this.listOfSelectedEmployers.map(item => item.id),

        page: Number(this.currentPage),
        count: Number(this.pageCount),
        previously_reviewed: this.isPreviouslyReviewed,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
  },
  computed: {
    ...mapGetters([
      'getCandidateById',
      'getUserProfile',
      'getEmployersDropdown',
      'getReviewApplicationsList',
      'getNextPage',
      'getTotalPages',
      'getCurrentPage',
      'getSourceList',
      'getPipelines',
      'getJobAdById',
    ]),
    getApplicationsList() {
      return this.$store.state.reviewApplicationsList;
    },
    /* getDateAndTime() {
      const dt = new Date();

      // ensure date comes as 01, 09 etc
      const DD = ('0' + dt.getDate()).slice(-2);

      // getMonth returns month from 0
      const MM = ('0' + (dt.getMonth() + 1)).slice(-2);

      const YYYY = dt.getFullYear();

      const hh = ('0' + dt.getHours()).slice(-2);

      const mm = ('0' + dt.getMinutes()).slice(-2);

      // const ss = ('0' + dt.getSeconds()).slice(-2);

      const date_string = `${YYYY}-${MM}-${DD}`;
      return date_string;
    }, */
  },
  watch: {
    /*  selectedQualification: (newVal, oldVal) => {
      if (newVal && oldVal) {
        console.log('selectedQualification changed: ', newVal, ' | was: ', oldVal);
        this.isSubmitted = true;
      }
    },
    selectedStage: (newVal, oldVal) => {
      if (newVal && oldVal) {
        console.log('selectedStage changed: ', newVal, ' | was: ', oldVal);
        this.isSubmitted = true;
      }
    }, */
  },
  updated() {
    this.reviewApplicationsLocalList = this.getReviewApplicationsList;
  },
  mounted() {
    // this.displayResultsBasedOnScreen();

    this.retrieveUserProfile()
      .then(() => {
        this.retrieveEmployersDropdown();
      })
      .catch(() => {
        this.isLoading = false;
      });

    this.retrieveReviewApplications({
      search_word: this.searchText,
      employers: this.listOfSelectedEmployers.map(item => item.id),
      page: Number(this.currentPage),
      count: Number(this.pageCount),
      previously_reviewed: this.isPreviouslyReviewed,
    })
      .then(({ data }) => {
        this.isLoading = false;
        this.reviewApplicationsLocalList = data.data;
      })
      .catch(err => {
        this.isLoading = false;

        this.$toasted.error(errorService(err), {
          theme: 'bubble',
          icon: 'fa-times-circle',
          position: 'bottom-right',
          duration: 8000,
        });
      });

    this.dragAndDropCapable = this.determineDragAndDropCapable();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/_mixins';

.overflow {
  overflow-y: auto;
  max-height: 63vh;
}
.loader-con {
  position: relative;
  width: 100%;
  height: 100%;
}
/* Upload Files */
.remove-container {
  .remove {
    cursor: pointer;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: 0.6;
  }

  .remove:hover {
    color: $color-status-closed;
  }
}

.table-responsive {
  overflow: initial;
}

/* TODO:: use bootstrap utility instead of this */
progress[value] {
  /* Reset the default appearance */
  -webkit-appearance: none;
  appearance: none;

  width: 400px;
  height: 5px;
}

progress[value]::-webkit-progress-bar {
  background-color: #eee;
  border-radius: 2px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
}

progress[value]::-webkit-progress-value {
  background-color: $color-orange;
  border-radius: 2px;
  -webkit-animation: animate-stripes 5s linear infinite;
  animation: animate-stripes 5s linear infinite;
}

@-webkit-keyframes animate-stripes {
  100% {
    background-position: -100px 0px;
  }
}

@keyframes animate-stripes {
  100% {
    background-position: -100px 0px;
  }
}
/* End Upload Files */

.remove {
  cursor: pointer;
  font-size: 1.3rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.6;
}

.remove:hover {
  color: $color-status-closed;
}

.fa-user-check {
  font-size: 18px;
}

.controls-wrap {
  width: 100%;
  .integration-group {
    width: 36.7%;
  }
}

.edit-pen-svg {
  width: 10;
  height: 10;
  fill: #007bb5;
}

/* .svg-icon {
  color: #007bb5;
  width: 24px;
  height: 24px;
} */

.mobile-only {
  display: none;
}

.desktop-only {
  display: block;
}

.desktop-only-table {
  display: table;
  table-layout: auto;
}

.card {
  height: 81.7vh;
}

@media only screen and (max-width: 1251px) {
  .card {
    margin: 24px 23px 0 23px !important;
  }
}

@media only screen and (max-width: 992px) {
  .card {
    height: 100vh;
    margin: 24px 0 0 0 !important;
  }
  .desktop-only {
    display: none;
  }
  .desktop-only-table {
    display: none;
  }
  .table-controls {
    display: block !important;
    .controls-wrap {
      .integration-group {
        margin-right: 0 !important;
      }
      display: block !important;
      .published {
        font-size: 15px !important;
        margin-top: 15px;
      }
    }
  }
  .mobile-qualify {
    display: block;
    .list-unstyled {
      font-family: $font-family-sans-lato;
      li {
        position: relative;
        border-bottom: 1px solid #ddd;
        a {
          text-decoration: none;
        }
        padding: 9px 15px 15px 15px;
        .name a {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .email {
          font-size: 14px;
          color: #f05a00;
        }
        .company {
          font-weight: 600;
          a {
            color: #333 !important;
          }
        }
        .position {
          font-weight: 500;
          a {
            color: #5f5f5f;
          }
        }
        .documents {
          margin-top: 8px;
          a {
            display: inline-block;
          }
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .card {
    height: 100vh;
  }
  .desktop-only {
    display: none;
  }
  .desktop-only-table {
    display: none;
  }
  .table-controls {
    display: block !important;
    .controls-wrap {
      .integration-group {
        margin-right: 0 !important;
      }
      display: block !important;
      .published {
        font-size: 15px !important;
        margin-top: 15px;
      }
    }
  }
  .mobile-qualify {
    display: block;
    .list-unstyled {
      font-family: $font-family-sans-lato;
      li {
        position: relative;
        border-bottom: 1px solid #ddd;
        a {
          text-decoration: none;
        }
        padding: 9px 15px 15px 15px;
        .name a {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .email {
          font-size: 14px;
          color: #f05a00;
        }
        .company {
          font-weight: 600;
          a {
            color: #333 !important;
          }
        }
        .position {
          font-weight: 500;
          a {
            color: #5f5f5f;
          }
        }
        .documents {
          margin-top: 8px;
          a {
            display: inline-block;
          }
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 576px) {
  .card {
    height: 100vh;
    margin-top: 0 !important;
  }
  .table-controls {
    display: block !important;
    .controls-wrap {
      .integration-group {
        margin-right: 0 !important;
      }
      display: block !important;
      .published {
        font-size: 15px !important;
        margin-top: 15px;
      }
    }
  }
  .mobile-qualify {
    display: block;
    .list-unstyled {
      font-family: $font-family-sans-lato;
      li {
        position: relative;
        border-bottom: 1px solid #ddd;
        a {
          text-decoration: none;
        }
        padding: 9px 15px 15px 15px;
        .name a {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .email {
          font-size: 14px;
          color: #f05a00;
        }
        .company {
          font-weight: 600;
          a {
            color: #333 !important;
          }
        }
        .position {
          font-weight: 500;
          a {
            color: #5f5f5f;
          }
        }
        .documents {
          margin-top: 8px;
          a {
            display: inline-block;
          }
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .desktop-only {
    display: none;
  }
  .desktop-only-table {
    display: none;
  }
}
</style>
